module.exports = __webpack_public_path__ + "img/IMG-20200316-WA0046.141c8389.jpg";